import React, { useEffect, useState } from 'react';
import {
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    FormControl,

    Input,
    Box,
    Divider,
} from '@chakra-ui/react';
import QuotationTable from './QuotationTable'; // Import the new table component
import { Col, Form, InputGroup, Row } from 'react-bootstrap';
import CurrencyFormat from 'react-currency-format';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { fetchAsyncDeleteQuotation } from 'redux/quotationSlice';
import { useToasts } from 'react-toast-notifications';
import { fetchAsyncFilePreviewData } from 'redux/userSlice';
import SpinnerLoader from 'components/Spinner/SpinnerLoader';


const QuotationForm = (
    { 
        closeModal, 
        isOpen, 
        requestedAmount, 
        handleData,
        uploadedData,
        expenseId,
        allQuotation,
        
    }) => {
    const [quotations, setQuotations] = useState([]);
    const [remarks, setRemarks] = useState('');
    const [amount, setAmount] = useState('');
    const [files, setFiles] = useState([]);
    const dispatch = useDispatch(); 
    const { addToast } = useToasts();

    const [isLoading,setIsLoading] = useState(false)

    
    useEffect(()=>{
        if(allQuotation && allQuotation?.length){

            setQuotations(allQuotation)
        }
    },[allQuotation])

    useEffect(()=>{
        if(uploadedData && uploadedData?.files?.length){
            setRemarks(uploadedData?.remarks)
            setAmount(uploadedData?.amount);
          
        }
    },[uploadedData])
    
    const handleDeleteQuotation = (key,id,spId) => {
        Swal.fire({
          title: "Confirm Deletion: This quotation will be permanently removed.",
          text: ``,
          icon: "warning",
          confirmButtonColor: "#d33",
          confirmButtonText: "Delete",
          showCancelButton: true,
          customClass: {
            container: "sweet_containerImportant",
            confirmButton: "sweet_confirmbuttonImportant",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            setIsLoading(true)
            const sendData = {
              id: id,
              key: key,
              expenseId:expenseId,
              spId:spId || ""
            };
            dispatch(fetchAsyncDeleteQuotation(sendData)).then((res) => {
                const quotations = res.payload?.quotations;
                if(quotations) {

                  setQuotations(quotations)
                  addToast("Quotation deleted successfully!", { appearance: "success" });
                  setIsLoading(false)

                }
               
            });
          }
        });
      };
    useEffect(()=>{
        if(requestedAmount){
            setAmount(requestedAmount)
        }
    },[requestedAmount])


    const handleAddQuotation = async (e) => {
        e.preventDefault();
        if(!amount){
            addToast("Amount Is required!", { appearance: "error" });
            return
        }
        if(!files?.length && !remarks){
            addToast("Files or Remarks are required!", { appearance: "error" });
            return
        }

        handleData({remarks,amount,files});
        resetForm();
        addToast("Quotation Uploaded successfully!", { appearance: "success" });
        closeModal();
       
    };

    const resetForm = () => {
        setRemarks('');
        setAmount('');
        setFiles([]);
    };
    const handlePreview = async (key, spId) => {
      setIsLoading(true)

      try {
        const data = { key:key, spId:spId };
        const response = await dispatch(fetchAsyncFilePreviewData(data)).unwrap();
        const contentType = response.headers['Content-Type'] || response.headers['content-type']; 
        
        const blob = new Blob([response.data], { type: contentType });
        const pdfUrl = window.URL.createObjectURL(blob);
        window.open(pdfUrl, '_blank'); 
        setIsLoading(false)

      } catch (error) {
        setIsLoading(false)

        addToast(`Error fetching PDF preview: ${error.message}`, { appearance: "error" });
      }
    };

    return (
      <>
        <Modal isOpen={isOpen} onClose={closeModal}  className="modal-main" size="xl">
          <ModalOverlay />
          <ModalContent 
          top="0"
          margin="0 auto"
          bottom="0"
          className="add-form-modal-content"
          >
            <div className="fixed-header">
            <ModalHeader className="expense-modal-header">
              Add Quotation
            </ModalHeader>
            <ModalCloseButton />
          </div>
           
            { isLoading ? <SpinnerLoader/>
            :

            <ModalBody>
              <Form className='addForm'>
              <div className="form-card">
               <h5 className="mt-0">Quotation Details</h5>

                <Row>
                  <Col>
                  <Box display="flex" className="input-box">

                    <Form.Label><span className="span-star">Requested Amount *</span></Form.Label>
                    

                    <InputGroup >
                      <InputGroup.Text>
                        <span className="rupee-symbol">₹</span>{" "}
                      </InputGroup.Text>
                      <CurrencyFormat
                        customInput={Form.Control}
                        type="text"
                        disabled
                        name="totalPayAmount"
                        placeholder="Total Amount"
                        value={parseFloat(amount || 0)}
                        thousandSeparator={true}
                        onValueChange={(e) => {
                          setAmount(e.value);
                        }}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                    </InputGroup>
                    </Box>
                  </Col>
                  <Col>
                  <Box display="flex" className="input-box">

                  <Form.Label className='w-50'>Upload Files (img/pdf)</Form.Label>

                    <FormControl mb={4}>
                      <Input
                        type="file"
                        className='quotation-file-input'
                        multiple
                        accept="image/*,.pdf"
                        onChange={(e) => setFiles(e.target.files)}
                      />
                    
                    </FormControl>
                    </Box>
                  </Col>
                </Row>

                <Row className='mt-3'>
                  <Col>
                  <Box display="flex" className="input-box">

                    <Form.Label>Remarks </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Type Here..."
                      name="remarks"
                      value={remarks}
                      onChange={(e) => setRemarks(e.target.value)}
                    />
                    </Box>
                  </Col>
                </Row>
                <Box display="flex" alignItems="center" justifyContent="center">

                <Button className='submit-btn mt-3' type="submit" onClick={(e)=>handleAddQuotation(e)} colorScheme="green">
                  Add
                </Button>
                </Box>
              
                </div>
              </Form>
              
              <Box mt={6}>
                {quotations && quotations?.length ?
                <QuotationTable
                  quotations={quotations}
                  handlePreview={(key,spId)=>handlePreview(key,spId)}
                  handleDelete={(key,id,spId)=>handleDeleteQuotation(key,id,spId)}
                />
                :
                ""
                }
              </Box>
            </ModalBody>
            }
            <ModalFooter>
              <Button className='close-btn btn' onClick={closeModal}>Close</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
};

export default QuotationForm;
